import { Box, Button, Modal, ThemeOverride } from "@modernatx-internal/ui-kit-react";
import React from "react";

import { SoftGatingModalBlockProps } from "@/types/Block";

import { BlockText } from "../BlockText";

export const SoftGatingModal: React.FC<SoftGatingModalBlockProps> = ({
  buttonText,
  text,
  footer,
  gatingType,
  label
}) => {
  const [softGatingVisible, softGatingVisibleSet] = React.useState(false);
  const CONFIRMED_VALUE = "1";

  React.useEffect(() => {
    const confirmedValue = localStorage.getItem(gatingType);
    softGatingVisibleSet(confirmedValue !== CONFIRMED_VALUE);
  }, [gatingType]);

  const handleClick = React.useCallback(() => {
    localStorage.setItem(gatingType, CONFIRMED_VALUE);
    softGatingVisibleSet(false);
  }, [gatingType, softGatingVisibleSet]);

  // No render on server to prevent hydration mismatch
  if (typeof window === "undefined") {
    return null;
  }

  return (
    <Modal isOpen={softGatingVisible} size="sm" aria-label={label}>
      <Box sx={{ py: [5, 10, 15], px: [5, 10, 20] }}>
        <BlockText {...text} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: ["100%", null, "fit-content"]
          }}
        >
          <ThemeOverride mode="dark">
            <Button size="small" onClick={handleClick}>
              <BlockText as="span" text={buttonText} />
            </Button>
          </ThemeOverride>
          {footer && <BlockText {...footer} />}
        </Box>
      </Box>
    </Modal>
  );
};
